function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from '@finect/tabular-icons/heart';
import { withTheme } from 'styled-components';
import { getYearlyPerformance, getPeriodPerformance, getFundDisplayName, getFundsSheetPath, getProductTypeByAPISubtype } from '@finect/front-resources/Products';
import { SrriBar } from '../../../SrriBar';
import { AreaChart } from '../../../../AreaChart';
import { PercentLabel } from '../../../Labels';
import { Stars } from '../../../../Stars';
import { getYearsFromNow } from '../../../utils';
import { HeartAction, LikeContainer, Inner, Step, Facts, Fact, FactHeader, FactValue, CardContent, ProductName, Graph, Yields } from './partials';
export var ProductCard = function (_React$Component) {
  _inherits(ProductCard, _React$Component);
  var _super = _createSuper(ProductCard);
  function ProductCard() {
    var _this;
    _classCallCheck(this, ProductCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleFollow", function () {
      _this.props.onFollow && _this.props.onFollow(_this.props.product.id, !_this.props.following);
    });
    _defineProperty(_assertThisInitialized(_this), "getNaturalPerformance", function (product, dateTimePeriod, type) {
      var data = getPeriodPerformance(product.stats, dateTimePeriod, type);
      return data ? data.value : null;
    });
    _defineProperty(_assertThisInitialized(_this), "getYearlyPerformance", function (product, year) {
      var data = getYearlyPerformance(product.stats, year);
      return data ? data.value : null;
    });
    return _this;
  }
  _createClass(ProductCard, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(prevProps) {
      if (prevProps.following !== this.props.following) {
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        product = _this$props.product,
        following = _this$props.following,
        theme = _this$props.theme,
        withSPA = _this$props.withSPA;
      var _theme$partner$produc = theme.partner.productsFeatures,
        productsFeatures = _theme$partner$produc === void 0 ? ['rating'] : _theme$partner$produc;
      var productType = getProductTypeByAPISubtype(product.subtype);
      var productPath = product.isin ? getFundsSheetPath(theme, productType, product) : '';
      var statsPerformanceMonths = product.stats.performance.months || [];
      var orderedStatsPerformanceMonths = statsPerformanceMonths.sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      });
      var lineChartData = orderedStatsPerformanceMonths.slice(-11).map(function (monthData) {
        return monthData.value;
      });
      var lineChartUp = lineChartData.length > 0 ? this.getNaturalPerformance(product, 'M12', 'accumulated') > 0 : true;
      var lineChartStart = 100;
      var lineChartValues = lineChartData.map(function (value) {
        return lineChartStart *= 1 + value / 100;
      });
      lineChartValues.unshift(100);
      var isFollowable = typeof this.props.onFollow === 'function';
      var years = getYearsFromNow(3, 'asc');
      var linkProps = productPath ? withSPA ? {
        as: Link,
        to: productPath
      } : {
        as: 'a',
        href: productPath
      } : {};
      return React.createElement(Inner, null, React.createElement(CardContent, null, React.createElement("div", null, React.createElement(LikeContainer, null, theme.partner.user.actions && isFollowable ? React.createElement(HeartAction, {
        onClick: this.handleFollow,
        active: following,
        title: "A\xF1adir a favoritos"
      }, React.createElement(Heart, {
        size: "16px"
      })) : null), React.createElement(ProductName, _extends({
        "data-fi-event": "product-card"
      }, linkProps), React.createElement("span", null, getFundDisplayName(product, productType)))), React.createElement(Facts, null, productsFeatures.includes('rating') ? React.createElement(Fact, {
        bottomMargin: true
      }, React.createElement(FactHeader, null, "Valoraci\xF3n"), React.createElement(FactValue, null, React.createElement(Stars, {
        variant: "small",
        value: product.score,
        reviews: 3
      }))) : null, React.createElement(Fact, {
        bottomMargin: true
      }, React.createElement(FactHeader, null, "Riesgo"), React.createElement(FactValue, null, product.srri ? React.createElement(SrriBar, {
        value: product.srri,
        size: "tiny"
      }) : React.createElement(Step, {
        light: true,
        small: true
      }, "\u2014"))), React.createElement(Yields, null, React.createElement("tbody", null, React.createElement("tr", null, years.map(function (year, index) {
        return React.createElement("th", {
          key: index
        }, year);
      }), React.createElement("th", null, new Date().getFullYear())), React.createElement("tr", null, years.map(function (year, index) {
        return React.createElement("td", {
          key: index
        }, React.createElement(PercentLabel, {
          decimals: 1,
          withNegative: true,
          withLightEmpty: true,
          color: "negative",
          value: _this2.getYearlyPerformance(product, year)
        }));
      }), React.createElement("td", null, React.createElement(PercentLabel, {
        decimals: 1,
        withNegative: true,
        withLightEmpty: true,
        value: this.getNaturalPerformance(product, 'M0', 'accumulated')
      }))))))), React.createElement(Graph, {
        up: lineChartUp,
        noData: lineChartData.length < 2
      }, lineChartData.length < 2 ? null : React.createElement(AreaChart, {
        width: 220,
        height: 220,
        stroke: lineChartUp ? 'rgba(162,231,197,0.5)' : 'rgba(252,176,177,0.2)',
        fill: lineChartUp ? 'rgba(162,231,197,0.1)' : 'rgba(252,176,177,0.1)',
        data: lineChartValues,
        strokeWidth: 2
      })));
    }
  }]);
  return ProductCard;
}(React.Component);
_defineProperty(ProductCard, "defaultProps", {
  following: false,
  onFollow: null,
  withSPA: false
});
export default withTheme(ProductCard);